import Cookies from "universal-cookie";
const cookies = new Cookies();

export const generateValidCookie = () => {
  const expires = new Date(Date.now() + 60 * 60 * 1000); // 1 hour
  cookies.set('valid', 'true', {
    expires,
    path: '/',
    sameSite: 'Lax',
    secure: true,
  });
};

export const generateTokenCookie = token => {
  cookies.set('token', token, {
    path: '/',
    sameSite: 'Lax',
    secure: true,
  });
};

export const createNewSessionCookies = token => {
  generateValidCookie();
  generateTokenCookie(token);
};

export const clearCookies = () => {
  cookies.remove('token', { path: '/' });
  cookies.remove('valid', { path: '/' });
};
